import { PropsWithChildren, ReactElement } from "react";
import { MoreInfo } from "../MoreInfo/MoreInfo";
import styles from "./InputWithMoreInfo.module.less";

export type InputWithMoreInfoProps = {
	onMoreInfo(): void;
	trackingId?: string;
};

export const InputWithMoreInfo = (props: PropsWithChildren<InputWithMoreInfoProps>): ReactElement => {
	const {
		onMoreInfo,
		trackingId,
		children
	} = props;

	return (
		<div className={styles.root}>
			<div className={styles.input}>
				{children}
			</div>
			<div className={styles.moreInfo}>
				<MoreInfo
					onClick={onMoreInfo}
					trackingId={trackingId}
				/>
			</div>
		</div>
	);
};
InputWithMoreInfo.displayName = "InputWithMoreInfo";